/**
 * Assign stable anonymous labels to companies in a sorted distribution.
 *
 * Input:
 *   distribution      - array of { companyId, rank, ... } already sorted
 *                       (ascending by growth). The order IS the label order.
 *   currentCompanyId  - optional. The caller's own company gets "Uw organisatie"
 *                       instead of a letter.
 *
 * Output:
 *   Map<companyId, label> where label is:
 *     - "Uw organisatie" for the current company
 *     - "Organisatie A".."Organisatie Z" for the first 26 others (index-based)
 *     - "Organisatie 27", "Organisatie 28", ... beyond index 25
 *
 * Letter assignment is always based on index, not on a dense sequence. This
 * means a company's letter is tied to its rank and never shifts if the caller
 * changes — which makes the labels stable across views and easier to reason
 * about when comparing positions.
 */
const anonymizeCompanies = (distribution = [], currentCompanyId = null) => {
    const labels = new Map()

    distribution.forEach((row, index) => {
        if (row.companyId === currentCompanyId) {
            labels.set(row.companyId, 'Uw organisatie')
            return
        }

        const label = index < 26
            ? `Organisatie ${String.fromCharCode(65 + index)}`
            : `Organisatie ${index + 1}`

        labels.set(row.companyId, label)
    })

    return labels
}

export default anonymizeCompanies
